'use strict';

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Fab = function Fab(_ref) {
  var theme = _ref.theme,
      left = _ref.left,
      mini = _ref.mini,
      title = _ref.title,
      fabOpen = _ref.fabOpen,
      enterCb = _ref.enterCb,
      leaveCb = _ref.leaveCb,
      clickCb = _ref.clickCb,
      children = _ref.children,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor; // determine where it should be docked at the bottom, if at all

  var dockedStyle = null; // if docked, which side

  if (left === true) {
    dockedStyle = {
      left: 25
    };
  } else {
    dockedStyle = {
      right: 25
    };
  } // if should be mini or regular size


  var miniStyle = null;
  if (mini === true) miniStyle = {
    height: 40,
    lineHeight: '40px',
    padding: '0 10px',
    minWidth: 40
  }; // if left, we need to adjust the styles

  var leftStyle = null;
  if (left === true) leftStyle = {
    textAlign: 'left',
    left: '10px',
    right: 'inherit'
  };
  return _react2["default"].createElement('span', {
    onMouseEnter: function onMouseEnter() {
      return enterCb();
    },
    onMouseLeave: function onMouseLeave() {
      return leaveCb();
    },
    onClick: function onClick() {
      return clickCb();
    },
    className: 'nwc--fab-wrapper nwc--docked ' + theme,
    style: _extends({}, dockedStyle)
  }, _react2["default"].createElement('span', {
    className: fabOpen === true ? 'nwc--fab-mask' : 'nwc--fab-mask opacity--0'
  }), _react2["default"].createElement('div', {
    className: fabOpen === true ? 'nwc--fab-menu' : 'nwc--fab-menu opacity--0',
    style: _extends({}, leftStyle)
  }, _react2["default"].createElement('span', {
    className: left === true ? 'left' : 'right'
  }, children)), _react2["default"].createElement('button', {
    type: 'button',
    className: 'nwc--fab padding--none border--none',
    style: _extends({}, miniStyle, {
      background: backgroundColor,
      color: textColor
    })
  }, _react2["default"].createElement('div', null, title)));
};

Fab.defaultProps = {
  theme: '',
  left: false,
  mini: false,
  title: '+',
  enterCb: function enterCb() {
    return null;
  },
  leaveCb: function leaveCb() {
    return null;
  },
  clickCb: function clickCb() {
    return null;
  },
  backgroundColor: '',
  textColor: ''
};
Fab.propTypes = {
  theme: _propTypes.PropTypes.string,
  left: _propTypes.PropTypes.bool,
  mini: _propTypes.PropTypes.bool,
  title: _propTypes.PropTypes.string,
  fabOpen: _propTypes.PropTypes.bool.isRequired,
  enterCb: _propTypes.PropTypes.func,
  leaveCb: _propTypes.PropTypes.func,
  clickCb: _propTypes.PropTypes.func,
  children: _propTypes.PropTypes.object.isRequired,
  backgroundColor: _propTypes.PropTypes.string,
  textColor: _propTypes.PropTypes.string
};
exports["default"] = Fab;